import { SAFE_AREA_BOT, SAFE_AREA_TOP } from '@mopla/constants';

export const getSafeAreas = () => {
	const styles = getComputedStyle(document.documentElement);

	return {
		top: parseFloat(styles.getPropertyValue(SAFE_AREA_TOP)) || 0,
		bot: parseFloat(styles.getPropertyValue(SAFE_AREA_BOT)) || 0,
		doc: window.innerHeight,
	};
};
